import { useSelector } from 'react-redux';

import { makeGetMilestone } from 'selectors/milestones';

const getMilestone = makeGetMilestone();

export const useMilestone = milestoneId => {
    const milestone = useSelector(({ milestones }) => getMilestone(milestones.items, milestoneId));

    return milestone;
};
